import { render, staticRenderFns } from "./XuVisitDialog.vue?vue&type=template&id=407fc950&scoped=true"
import script from "./XuVisitDialog.vue?vue&type=script&lang=js"
export * from "./XuVisitDialog.vue?vue&type=script&lang=js"
import style0 from "./XuVisitDialog.vue?vue&type=style&index=0&id=407fc950&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407fc950",
  null
  
)

export default component.exports